import { render, staticRenderFns } from "./ProductTagIndex.vue?vue&type=template&id=73fdb9b8"
import script from "./ProductTagIndex.vue?vue&type=script&lang=js"
export * from "./ProductTagIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports